import { render, staticRenderFns } from "./EditUserRoles.vue?vue&type=template&id=a848087e"
import script from "./EditUserRoles.vue?vue&type=script&lang=js"
export * from "./EditUserRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports